import {fork} from 'redux-saga/effects';

import {sagas as interestInvite} from './invite';
import {sagas as interestDeal} from './deal';
import {sagas as interestInvestor} from './investor';
import {sagas as interestAccreditation} from './accreditation';
import {sagas as interestInvestment} from './investment';
import {sagas as InterestConfirmed} from './confirmed';

export function* sagas() {
  yield fork(interestInvite);
  yield fork(interestDeal);
  yield fork(interestInvestor);
  yield fork(interestAccreditation);
  yield fork(interestInvestment);
  yield fork(InterestConfirmed);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/index.js